import React from "react";

import { Spinner } from "@/client/components/ui/index";
import { BackIcon } from "@/client/icons";

/**
 * Responsive master-detail layout.
 * - Desktop: side-by-side (280px list + flexible detail).
 * - Mobile: shows list OR detail, with a back button on the detail view.
 */
export function MasterDetailLayout({
  list,
  detail,
  hasSelection,
  detailLoading,
  onBack,
  backLabel,
  emptyMessage,
}: {
  list: React.ReactNode;
  detail: React.ReactNode | null;
  hasSelection: boolean;
  detailLoading?: boolean;
  onBack: () => void;
  backLabel: string;
  emptyMessage: string;
}) {
  const showDetail = hasSelection && (detail || detailLoading);

  return (
    <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-6 min-h-[calc(100dvh-160px)]">
      {/* List — hidden on mobile when detail is open */}
      <div className={showDetail ? "hidden md:block" : "block"}>{list}</div>

      {/* Detail — on mobile, shown with back button */}
      <div className={showDetail ? "block" : "hidden md:block"}>
        {showDetail ? (
          <>
            <button
              onClick={onBack}
              className="md:hidden flex items-center gap-1 text-sm text-term-accent mb-4 cursor-pointer"
            >
              <BackIcon width={16} height={16} />
              {backLabel}
            </button>
            {detailLoading && !detail ? <Spinner /> : detail}
          </>
        ) : (
          <div className="flex items-center justify-center text-term-text-muted text-sm rounded-xl h-full min-h-48 border border-dashed border-term-border">
            {emptyMessage}
          </div>
        )}
      </div>
    </div>
  );
}
